'use strict';

angular.module('internal.services')
    .directive('internalServiceHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'services/components/service-header/service-header.html',
            controller: 'InternalServiceHeader',
            replace: true
        };
    }])
    .controller('InternalServiceHeader', ['$scope', '$filter', function ($scope, $filter) {
        $scope.date30 = function () {
            var date30 = new Date();
            date30.setDate(date30.getDate() + 30);
            return date30;
        }
    }])
;